import $ from 'jQuery';

export default function () {
  $(function() {
    image_gallery_init();
    gallery_modal();
  });

  $(window).on('resize',function() {
    image_gallery_init();
  });

  var $gallery = $('.block--image-gallery');
  var lastClick = 0;

  function image_gallery_init() {
    $gallery.each(function() {
      var $this = $(this),
          $images_container = $this.find('.image-gallery--images'),
          $item = $this.find('.image-gallery--item'),
          $loadMore = $this.find('.load_more'),
          itemCount = 0;

      if ( !$this.hasClass('complete') ) {
        $item.hide();

        // base style (down 599px)
        if ( $item.length > 6 ) {
          itemCount = 6;
        }

        // breakpoints
        // up 600px
        if ( !$('.image-gallery--helper--one:hidden').length ) {
          if ( $item.length > 9 ) {
            itemCount = 9;
          }
        }

        // up 800px
        if ( !$('.image-gallery--helper--two:hidden').length ) {
          if ( $images_container.hasClass('four_column') && $item.length > 9 ) {
            itemCount = 9;
          }
          else if ( $images_container.hasClass('six_column') && $item.length > 12 ) {
            itemCount = 12;
          }
        }

        // up 1000px
        if ( !$('.image-gallery--helper--three:hidden').length ) {
          if ( $images_container.hasClass('four_column') && $item.length > 12 ) {
            itemCount = 12;
          }
          else if ( $images_container.hasClass('six_column') && $item.length > 18 ) {
            itemCount = 18;
          }
        }

        $item.slice(0, itemCount).show();

        $loadMore.on('click', function(evt){
          evt.preventDefault();
          var $hiddenItem = $(this).prev().find('.image-gallery--item:hidden');
          $hiddenItem.slice(0, itemCount).slideDown();
          if ( $hiddenItem.length <= itemCount) {
            $(this).parents('.block--image-gallery').addClass('complete');
            $(this).remove();
          }
        });
      }    
    });
  }

  function gallery_modal() {
    $gallery.each(function() {
      var $modal = $(this).find('.image-gallery--modal');

      $(this).find('.image-gallery--trigger').on('click', function(evt) {
        evt.preventDefault();

        var imgID = $(this).attr('rel');

        // Show the modal
        $('html').addClass('modal-is-open');
        $modal
          .show()
          .find('#' + imgID).show();
        
        setTimeout(function () {
          $modal.addClass('active');
        }, 100);
      });

      // Use event delegation for the modal close button
      $modal.on('click', '#modalClose', function(e) {
        e.preventDefault();

        // Hide the modal
        $modal.removeClass('active');

        setTimeout(function() {
          $('html').removeClass('modal-is-open');
          $modal
            .hide()
            .find('.image-gallery--modal--item').hide();
          
        }, 300);
      });
    });
  }
}